import Vue from 'vue'
// import * as firebaseUtil from '../../firebase/firebaseUtil'

export default {
    state: {
        coupons: [],
        scannedCode: '',
        scannedCouponValid: true,
        referralPrograms: [],
        // }
    },
    actions: {},
    mutations: {

        coupons(state, payload) {
            if (Array.isArray(payload) && payload.length > 0) {
                state.coupons.splice(0, state.coupons.length);
                for (let c of payload) {
                    delete c.redeemer;
                    state.coupons.push(c);
                }
            }
        },

        scannedCouponValid(state, newValue) {
            state.scannedCouponValid = newValue;
        },

        referralPrograms(state, payload) {
            if (Array.isArray(payload)) {
                state.referralPrograms.splice(0, state.referralPrograms.length);
                for (let p of payload) {
                    state.referralPrograms.push(p);
                }
            }
        },

        scannedCode(state, newValue) {
            state.scannedCode = newValue;
        },

        deleteCouponByCode(state, code) {
            let i = -1;
            for (let c of state.coupons) {
                i++;
                if (c.couponCode === code) {
                    Vue.delete(state.coupons, i);
                    break;
                }
            }
        },

    },
    getters: {
        coupons: (state) => {
            return state.coupons;
        },

        referralPrograms: (state) => {
            return state.referralPrograms;
        },

        scannedCode: (state) => {
            return state.scannedCode;
        },

        scannedCouponValid: (state) => {
            return state.scannedCouponValid;
        },

        getCouponByCode: (state) => (code) => {
            return state.coupons.find(c => c.couponCode === code)
        },

        getScannedCoupon: (state) => {
            // console.log('coupons try to getScannedCoupon with scannedCode = ' + state.scannedCode + ' and coupons.length = ' + state.coupons.length);
            if (state.scannedCode.length > 0) {
                return state.coupons.find(c => {
                    return c.couponCode && (c.couponCode === state.scannedCode)
                })
            }
            return null;
        },

    }
};